import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { NoticeBar, Collapse, CollapseItem, ActionSheet, Button, Overlay, Loading } from "vant";
import moment from "moment";
import flightService from "@/service/flightService";
import { Categorys, OrderStatus, AmendStatus, ActiveStatus, BusinessType, DealStatus, ServiceType, categoryMap, PriceType } from "@/model/Base";
import { FlightOrderEntity } from "@/model/Flight";
import { WorkTaskEntity } from "@/model/Work";
import _ from "lodash";
import { BtripTaskEntity, BtripContraryEntity } from "@/model/Btrip";
import workService from "@/service/workService";
import btripServcice from "@/service/btripServcice";
import { OrderEntity } from "@/model/Order";
import { orderService } from "@/service/orderService";
import { TradeDealEntity } from "@/model/Bill";
import billService from "@/service/billService";
import logsService from "@/service/logsService";
import { LogInfoEntity } from "@/model/Logs";
import { ProfileInfo } from "@/model/system";
import { DurationTime, isApp, isWeiXin } from "@/utils/utils";
@Component({
  name: "flightOrderInfo",
  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [NoticeBar.name]: NoticeBar,
    [ActionSheet.name]: ActionSheet,
    [Button.name]: Button,
    [Overlay.name]: Overlay,
    [Loading.name]: Loading,
  },
  filters: {
    showDateWeek(value: string) {
      let date = moment(value);
      let weeks: any = {
        0: "日",
        1: "一",
        2: "二",
        3: "三",
        4: "四",
        5: "五",
        6: "六",
      };
      let week = weeks[date.day()];
      return `${date.format("MM.DD")} (周${week})`;
    },
    DurationTime,
  },
})
export default class orderInfo extends Vue {
  //props
  @Prop()
  taskGroups?: any[];

  @Prop()
  order!: FlightOrderEntity;

  @Prop()
  task!: WorkTaskEntity;

  @Prop()
  tasks!: WorkTaskEntity[];

  @Prop()
  mainTasks!: WorkTaskEntity[];

  @Prop()
  salesTasks!: WorkTaskEntity[];

  @Prop()
  amendTasks!: WorkTaskEntity[];

  @Prop()
  IsChangeOrRefunds?: any[];

  //data
  activeNames = [];
  showApproval = false;
  isLoading = false;

  service: orderService = flightService;

  //computed
  //mounted
  mounted() {
    (window as any).info = this;
    this.RefundJudge();
    this.loadTrades();
  }

  get canChange(): boolean {
    return this.order.ClientOrderStatus == OrderStatus.Finished && this.RefundJudges.length > 0;
  }
  get isChang(): boolean {
    return this.order.ClientOrderStatus == OrderStatus.Finished && this.RefundJudges.length > 0 && this.order.BusinessType != BusinessType.Change;
  }
  //methods
  diffDays(DepartDate: string, ArrivalDate: string) {
    let ArrivalTimes = moment(ArrivalDate);
    let DepartTimes = moment(DepartDate);
    return ArrivalTimes.diff(DepartTimes, "days");
  }
  formatDate(value: Date, format: string = "YYYY-MM-DD") {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }

  gotoHandle() {
    this.showApproval = true;
  }
  gotoChange(task: any) {
    this.$router.push({
      path: "/order/change",
      query: {
        UniqueID: task.UniqueID,
        ServiceCode: task.ServiceCode,
        RuleType: "Change",
      },
    });
  }
  gotoRefund(task: any) {
    this.$router.push({
      path: "/order/refund",
      query: {
        UniqueID: task.UniqueID,
        ServiceCode: task.ServiceCode,
        RuleType: "Refund",
      },
    });
  }
  // showRules(value: any) {
  //   this.$emit("showRules", value);
  // }

  get Contrarys(): BtripContraryEntity[] {
    let btripOrder = this.btripTask && this.btripTask.BusinessInfo;
    return (btripOrder && btripOrder.Contrarys) || [];
  }
  get isOverproof() {
    return this.Contrarys.length > 0;
  }

  get ContraryDetails() {
    var title = "产品";
    if (this.order.ServiceType == ServiceType.FlightService) title = "机票";
    else if (this.order.ServiceType == ServiceType.HotelService) title = "酒店";
    else if (this.order.ServiceType == ServiceType.TrainService) title = "车次";
    var message =
      _.uniq(
        this.Contrarys.map(
          o => `${this.$root.$t("order_flight_flightorderinfo_weibeixiangqing")} ${o.ProductName} 违背 <b style='color:red;'>${o.ContraryInfo}</b> 政策 <b>推荐${title}<b/>: ${o.RefContrary}`
        )
      ).join(",") || "";
    return message;
  }

  get ContraryInfo() {
    return _.uniq(this.Contrarys.map(o => o.CauseName)).join(",") || "";
  }

  get ContraryCause() {
    return _.uniq(this.Contrarys.map(o => o.CauseName)).join(",");
  }

  get CauseDetails() {
    return _.uniq(this.Contrarys.map(o => o.CauseDetails)).join(",");
  }
  // AmendOrderData();
  get btripTasks() {
    let __self = this;
    let tasks: any = [];
    if (__self.order.ClientOrderStatus == OrderStatus.WaitPayment) {
      tasks = _.filter(__self.tasks, o => o.FlowCode == "Btrip" && __self.order.UnionID == o.UnionID);
    }
    let Amendlist = _.filter(__self.amendTasks, o => o.BusinessInfo.OriginID == __self.order.UniqueID);

    Amendlist.forEach(m => {
      if (m.BusinessInfo.ClientOrderStatus == AmendStatus.WaitConfirm) {
        let WorkTaskList = _.filter(__self.tasks, o => o.FlowCode == "Btrip" && m.BusinessInfo.UnionID == o.UnionID);
        tasks = tasks.concat(WorkTaskList);
      }
    });
    return tasks;
  }
  get ReasonText() {
    if (this.amendOrder.BusinessType == BusinessType.Amend) {
      return this.order.Reason;
    }
    if (this.order.BusinessType == BusinessType.Change) {
      return this.order.Reason;
    }
    return this.btripTask && this.btripTask.BusinessInfo && this.btripTask.BusinessInfo.IntentName;
  }

  get btripTask() {
    let tasks = _.filter(this.tasks, o => o.FlowCode == "Btrip" && this.order.UnionID == o.UnionID);
    let task = tasks[0] || {};
    this.$set(task, "Actives", task.Actives || []);
    return task;
  }

  isActive(WorkTask: WorkTaskEntity) {
    let __self = this;
    let Flag = false;

    let Acitves = _.filter(WorkTask.Actives, o => o.NodeID == WorkTask.ActiveNode && o.DutyCode == "executer");
    let Active = _.find(Acitves, o => _.some(__self.profile.Confers, { ConferCode: o.ActiveUserID }));
    if (Active) {
      if (Active.ActiveStatus == ActiveStatus.WaitDispose) {
        Flag = true;
      }
    } else {
      if (WorkTask.ActiveUserID == __self.profile.UserID) {
        Flag = true;
      }
    }
    return Flag;
  }

  get isTaskResolve() {
    let Flag = false;
    let __self = this;
    let result = _.find(__self.btripTasks, o => __self.isActive(o));
    if (result) {
      Flag = true;
    }
    return Flag;
  }

  get ChargeAmount() {
    let data = _.find(this.tasks, o => o.FlowCode == "Charge" && o.BusinessInfo.UnionID == this.order.UnionID);
    if (data) {
      return data.BusinessInfo.ReceiveAmount;
    }
    return 0;
  }
  get InsuranceAmount() {
    let data = _.filter(this.tasks, o => o.FlowCode == "Insurance" && o.BusinessInfo.UnionID == this.order.UnionID);
    if (data.length > 0) {
         return data.reduce((total, item) => total + item.BusinessInfo.ReceiveAmount, 0);
      }
    return 0;
  }

  get amendOrder() {
    let __self = this;
    let list = _.find(__self.amendTasks, o => o.BusinessInfo.OriginID == __self.order.UniqueID);
    if (list) {
      return list.BusinessInfo;
    } else {
      return __self.order;
    }
  }

  get isAmendActive() {
    let __self = this;
    let amends = _.find(
      __self.amendTasks,
      o => o.BusinessInfo.OriginID == __self.order.UniqueID && o.BusinessInfo.BusinessType == BusinessType.Amend && o.BusinessInfo.ClientOrderStatus == AmendStatus.WaitDispose
    );

    if (amends) {
      return true;
    }
    return false;
  }
  get isChangeActive() {
    const __self = this;
    if (__self.order.BusinessType != BusinessType.Change || __self.order.CreateUserID != __self.profile.UserID) {
      return false;
    }
    if (__self.order.ClientOrderStatus == DealStatus.WaitPayment || __self.order.ClientOrderStatus == DealStatus.WaitConfirm) {
      return true;
    }
    return false;
  }
  get isOrderActive() {
    const __self = this;
    if (__self.order.BusinessType != BusinessType.Sales || __self.order.CreateUserID != __self.profile.UserID) {
      return false;
    }
    if (__self.order.ClientOrderStatus == DealStatus.WaitPayment || __self.order.ClientOrderStatus == DealStatus.WaitConfirm) {
      return true;
    }
    return false;
  }

  get resolveText() {
    if (this.amendOrder.BusinessType == BusinessType.Amend) {
      return { resolve: this.$root.$t("order_orderInfo_yunxutuipiao"), reject: this.$root.$t("order_orderInfo_jujuetuipiao") };
    }
    if (this.order.BusinessType == BusinessType.Change) {
      return { resolve: this.$root.$t("order_orderInfo_yunxugaiqian"), reject: this.$root.$t("order_orderInfo_jujuegaiqian") };
    }
    return { resolve: this.$root.$t("order_orderInfo_shenpitongguo"), reject: this.$root.$t("order_orderInfo_shenpijujue") };
  }

  get askType() {
    if (this.amendOrder.BusinessType == BusinessType.Amend) {
      return { role: this.$root.$t("order_orderInfo_tuipiaoren"), reason: this.$root.$t("order_orderInfo_tuipiaoyuanyin") };
    }
    if (this.order.BusinessType == BusinessType.Change) {
      return { role: this.$root.$t("order_orderInfo_gaiqianren"), reason: this.$root.$t("order_orderInfo_gaiqianyuanyin") };
    }
    return { role: this.$root.$t("order_orderInfo_chuxingren"), reason: this.$root.$t("order_orderInfo_chuxingmudi") };
  }

  RefundJudges: any[] = [];

  RefundJudge() {
    this.service.RefundJudge(this.order.UniqueID!).then(json => {
      if (json.isSucc) {
        this.RefundJudges = json.result;
      }
    });
  }

  saveLog() {
    let result = "H5";
    if (isWeiXin()) {
      result = "微信";
    } else if (isApp()) {
      result = "APP";
    }
    const profile = this.profile;
    const logData: LogInfoEntity = {
      RoleID: profile.UserID,
      RoleName: profile.UserName,
      TargetID: this.order.UniqueID,
      TargetName: "订单审批",
      OwnerID: profile.CompanyID,
      ActionName: "审批方式",
      ActionResult: result,
      ServiceCode: "Task",
      ActionCode: "TaskResolve",
      AccessCode: "public",
      IsSuccess: 1150,
    };
    logsService.add(logData).then();
  }
  RejectReason: string = "";
  decision(decisionCode: string) {
    let amends: any[] = [];
    this.amendTasks.forEach((o: any) => {
      if (o.BusinessInfo.OriginID == this.order.UniqueID && o.BusinessInfo.ClientOrderStatus == AmendStatus.WaitConfirm) {
        this.tasks.forEach((n: any) => {
          if (n.FlowCode == "Btrip" && o.BusinessID == n.BusinessID) {
            amends.push(n);
          }
        });
      }
    });

    let taskIds = [];
    if (amends.length > 0) {
      taskIds.push([amends[0].TaskID]);
    } else {
      let task = _.find(this.tasks, o => o.UnionID == this.order.UnionID && o.FlowCode == "Btrip") as any;
      if (!task) {
        return;
      }
      taskIds.push(task.TaskID);
    }
    this.saveLog();
    // return;
    if (decisionCode == "approve") {
      taskIds.forEach(o => {
        workService.TaskResolve(o, {}).then(json => {
          if (json.isSucc) {
            this.showApproval = false;
            this.$root.$toast("审批成功");
            this.$emit("reload");
          }
        });
      });
    }
    if (decisionCode == "reject") {
      taskIds.forEach(o => {
        workService.TaskReject(o, {}).then(json => {
          if (json.isSucc) {
            this.showApproval = false;
            this.$root.$toast("拒绝成功");
            this.$emit("reload");
            // let btripData = {
            //   TaskID: o,
            //   RejectReason: this.RejectReason,
            // };
            // btripServcice.saveTripRejectReason(btripData).then(m => {
            //   if (m.isSucc) {
            //     this.$root.$toast("拒绝成功");
            //     this.$emit("reload");
            //   }
            // });
          } else {
            this.$root.$toast(json.message!);
          }
        });
      });
    }
  }

  CancelRefund() {
    let __self = this;
    let WorkTasks = _.cloneDeep(__self.tasks);
    let datas = _.filter(WorkTasks, o => o.FlowCode == "Flight" || o.FlowCode == "Hotel" || o.FlowCode == "Train" || o.FlowCode == "Tour");
    let Lists: any[] = [];
    let OrderInfoLists: any[] = [];
    datas.forEach(o => {
      let ClientOrderStatus = o.BusinessInfo.ClientOrderStatus;
      let Flag = __self.amendOrder.BusinessType == BusinessType.Amend && (ClientOrderStatus == AmendStatus.WaitConfirm || ClientOrderStatus == AmendStatus.WaitDispose);
      if (Flag) {
        OrderInfoLists.push(o.BusinessInfo);
      }
    });
    if (OrderInfoLists.length > 0) {
      OrderInfoLists.forEach(o => (o.OrderInfos = [o]));
      OrderInfoLists.forEach(o => Lists.push(o));
    }
    let OrderCancelLists = Lists;
    if (OrderCancelLists.length > 1) {
    } else if (OrderCancelLists.length > 0) {
      __self.CancelRefundOrder([OrderCancelLists[0].UniqueID]);
    }
  }
  CancelChange() {
    let __self = this;
    let WorkTasks = _.cloneDeep(__self.tasks);
    let datas = _.filter(WorkTasks, o => o.FlowCode == "Flight" || o.FlowCode == "Hotel" || o.FlowCode == "Train" || o.FlowCode == "Tour");
    let Lists: any[] = [];
    let OrderInfoLists: any[] = [];
    datas.forEach(o => {
      let ClientOrderStatus = o.BusinessInfo.ClientOrderStatus;
      let Flag = __self.order.BusinessType == BusinessType.Change && (ClientOrderStatus == DealStatus.WaitPayment || ClientOrderStatus == DealStatus.WaitConfirm);
      if (Flag) {
        OrderInfoLists.push(o.BusinessInfo);
      }
    });
    if (OrderInfoLists.length > 0) {
      OrderInfoLists.forEach(o => (o.OrderInfos = [o]));
      OrderInfoLists.forEach(o => Lists.push(o));
    }
    let OrderCancelLists = Lists;
    if (OrderCancelLists.length > 1) {
      this.$root.$toast("不同航司航程选择处理...待做");
    } else if (OrderCancelLists.length > 0) {
      __self.CancelChangeOrder([OrderCancelLists[0].UniqueID]);
    }
  }

  CancelChangeOrder(OrderIDs: string[]) {
    let __self = this;
    if (OrderIDs.length <= 0) {
      this.$root.$toast("没有可以取消的改签单");
      return;
    }
    __self.isLoading = true;
    let results = OrderIDs.map(
      o =>
        new Promise((resolve, reject) => {
          __self.service.OrderCancel(o).then(function(json) {
            resolve(json);
          });
        })
    );

    Promise.all(results).then(function(resolves: any[]) {
      __self.isLoading = false;
      let Flag = true;
      for (let i = 0; i < resolves.length; i++) {
        let resolve = resolves[i].isSucc;
        if (!resolve) {
          Flag = false;
          break;
        }
      }
      if (Flag) {
        __self.$toast("取消成功");
        __self.$emit("reload");
        if (__self.order.OrderStatus == OrderStatus.Finished) {
          __self.RefundJudge();
        }
        __self.loadTrades();
      } else {
        __self.$toast(resolves[0].message);
      }
    });
  }
  CancelRefundOrder(OrderIDs: string[]) {
    let __self = this;
    if (OrderIDs.length <= 0) {
      this.$root.$toast("没有可以取消的改签单");
      return;
    }
    __self.isLoading = true;
    let results = OrderIDs.map(
      o =>
        new Promise((resolve, reject) => {
          __self.service.OrderRefundCancel(o).then(function(json: any) {
            resolve(json);
          });
        })
    );

    Promise.all(results).then(function(resolves: any[]) {
      __self.isLoading = false;
      let Flag = true;
      for (let i = 0; i < resolves.length; i++) {
        let resolve = resolves[i].isSucc;
        if (!resolve) {
          Flag = false;
          break;
        }
      }
      if (Flag) {
        __self.$toast("取消成功");
        __self.$emit("reload");
        if (__self.order.OrderStatus == OrderStatus.Finished) {
          __self.RefundJudge();
        }
        __self.loadTrades();
      } else {
        __self.$toast(resolves[0].message);
      }
    });
  }

  isCanceling = false;
  CancelOrder() {
    this.isCanceling = true;
    this.service.OrderCancel(this.order.UniqueID!).then((o: any) => {
      this.isCanceling = false;
      if (o.isSucc) {
        this.$root.$toast("取消成功");
        this.$emit("reload");
      }else{
        this.$root.$toast(o.message);
      }
    });
  }
  VoucherNo(ConsumerID: any) {
    let __self = this;
    let list = _.find(__self.order.Vouchers, o => o.ConsumerID == ConsumerID);
    if (list) {
      return list;
    }
    return {};
  }
  ClientOrderName(value: any) {
    let __self = this;
    if (!value) return;
    if (value == OrderStatus.WaitPayment) {
      return "待审批";
    }
    return categoryMap[value].CategoryTitle;
  }
  ChangeOrRefund(ConsumerID?: any, Products?: any) {
    let __self = this;
    let list = _.find(__self.IsChangeOrRefunds, o => {
      return __self.order.UniqueID == o.UniqueID;
    });
    if (list) {
      let ServiceType = categoryMap[list.ServiceType];
      let result = _.map(list.Products, function(s) {
        return _.find(s.productProps, f => f.ConsumerID == ConsumerID).ConsumerCode;
      });
      let uniqResult = _.uniq(result);
      if (uniqResult.length == 1) {
        if (ServiceType) {
          let type = ServiceType.CategoryCode.replace("Service", "");
          return __self.$t("Categorys.All" + uniqResult[0] + type);
        }
      } else {
        _.remove(uniqResult, o => o == "Booked" || o == "Booking");
        if (ServiceType) {
          let type = ServiceType.CategoryCode.replace("Service", "");
          return uniqResult.map(o => __self.$t("Categorys." + o + type)).join(";");
        }
      }
    }
  }
  decoratePrice(Prices?: any) {
    let results: any[] = [];
    let isChange = this.order.BusinessType == BusinessType.Change;
    _.map(
      _.groupBy(Prices, g => {
        if (isChange && g.PriceType == PriceType.TicketFare) {
          g.PriceName = "升舱费";
        }
        if (g.GroupCode) return g.GroupCode;
        if (!isChange && (g.PriceType == PriceType.BuildFare || g.PriceType == PriceType.FuelFare || g.PriceType == PriceType.TaxFare)) {
          // if (g.PriceType == PriceType.BuildFare || g.PriceType == PriceType.FuelFare || g.PriceType == PriceType.TaxFare) {
          return g.PriceType;
        }
        if (g.PriceType == PriceType.ChangeFare) {
          g.PriceName = "改签费";
          return g.PriceType;
        }
        return "";
      }),
      o => {
        let result = Object.assign({}, o[0]);
        result.SalesPrice = _.sumBy(o, "SalesPrice");
        results.push(result);
      }
    );
    results = results.filter(o => {
      if (o.SalesPrice != 0) {
        return true;
      }
      if (o.PriceType == PriceType.TicketFare || o.PriceType == PriceType.ChangeFare || o.PriceType == PriceType.BuildFare || o.PriceType == PriceType.FuelFare) {
        return true;
      }
      return false;
    });
    return results.sort((a, b) => a.PriceType - b.PriceType);
  }

  Trades: TradeDealEntity[] = [];
  loadTrades() {
    billService.GetUserPayment(this.order.OrderID!, this.order.UnionID!).then(json => {
      if (json.isSucc && json.result) {
        this.Trades = json.result;
      }
    });
  }

  get activeIndex() {
    let actives = (this.btripTask.Actives || []) as any[];
    if (this.btripTask.TaskStatus == ActiveStatus.Finished) {
      return actives.length;
    }
    for (let i = 0; i < actives.length; i++) {
      const active = actives[i];
      if (active.NodeID == this.btripTask.ActiveNode) {
        return i;
      }
    }
    return actives.length;
  }

  get isPaymentActive() {
    let btripTask = this.btripTask as any;
    if (this.order.ClientOrderStatus != OrderStatus.WaitPayment) return false;
    if (btripTask.Actives.length == 0) return true;
    // return this.btripTask.TaskID && this.Trades.length > 0 && this.activeIndex == btripTask.Actives.length;
    return this.btripTask.TaskID && this.Trades.length > 0 && this.Trades[0].TradeStatus == 1612;
  }
  get isRepaymentActive() {
    return this.order.ClientOrderStatus == OrderStatus.Finished && this.Trades.length > 0;
  }

  Payment() {
    this.$router.push({
      path: "/trade/cashier",
      query: {
        OrderID: this.order.OrderID,
        PartnerID: this.order.ClientID,
        UnionID: this.order.UnionID,
      },
    });
  }
}
